import AsyncSidebarConnect from '@atlassian/jira-navigation-apps-sidebar-connect/src/async.tsx';
import AsyncSidebarCore from '@atlassian/jira-navigation-apps-sidebar-core/src/async.tsx';
import AsyncSidebarGlobalSettingsApps from '@atlassian/jira-navigation-apps-sidebar-global-settings-apps/src/async.tsx';
import AsyncSidebarGlobalSettingsSystem from '@atlassian/jira-navigation-apps-sidebar-global-settings-system/src/async.tsx';
import AsyncSidebarNextGen from '@atlassian/jira-navigation-apps-sidebar-next-gen/src/async.tsx';
import AsyncSidebarServiceDesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import AsyncSidebarSoftwareClassic from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import AsyncSidebarUser from '@atlassian/jira-navigation-apps-sidebar-user/src/async.tsx';

export const genericProjectSidebars = [
	// delete when cleaning up getWillShowNav4
	AsyncSidebarCore,
	AsyncSidebarNextGen,
	AsyncSidebarServiceDesk,
	AsyncSidebarSoftwareClassic,
	AsyncSidebarUser,
];

export const classicBoardSidebars = [AsyncSidebarSoftwareClassic, AsyncSidebarUser];

/**
 * Full page connect addons locations:
 * root/index
 * root/global-settings/addons
 * root/global-settings/system
 * project/any/index
 * project/any/reports
 * project/any/settings
 * All of them with the same URL pattern: /plugins/servlet/ac/addonKey/moduleKey
 * This is why additional data is needed to render proper navigation
 */

export const genericConnectSidebars = [
	...genericProjectSidebars,
	AsyncSidebarConnect,
	AsyncSidebarGlobalSettingsApps,
	AsyncSidebarGlobalSettingsSystem,
];
